// src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Stack, TextField, Typography } from '@mui/material';
import axios from 'axios';
import config from '../config.js';


const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const login_endpoint = config.LOGIN_ENDPOINT || 'http://localhost:5005/login';

  const handleLogin = async () => {
    try {
      const response = await axios.post(login_endpoint, { username, password });
      localStorage.setItem('token', response.data.token);
      navigate('/');
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 10 }}>
        <Typography variant="h5" align="center">Login to SwiftApprove</Typography>
        <Stack spacing={2} mt={3}>
          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
          {error && <Typography color="error">{error}</Typography>}
          <Button variant="contained" onClick={handleLogin}>Login</Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default Login;

